
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ptheoqklmemjhcnxuovf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0aGVvcWtsbWVtamhjbnh1b3ZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNjg3MTUsImV4cCI6MjA1Njk0NDcxNX0.GtyzMQQcCCrQV5u2LD2mG7sFvWKMZCDcIwrDcthxwqQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
